
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tips/[tip]",
      function () {
        return require("private-next-pages/tips/[tip]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tips/[tip]"])
      });
    }
  